export default () => ({
    contentWrapper: {
        padding: 0,
        marginBottom: 0
    }
});
